import React from "react";
import { Rocket } from "lucide-react";
import { formatEastern, useSiteInfo } from "../lib/siteInfo";

/** Staff-only strip on production before go-live. */
export function PrelaunchNotice() {
  const info = useSiteInfo();
  if (!info?.prelaunch) return null;
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-1.5 text-[11px] font-medium border-b" style={{ background: "#E8EEF4", color: "#0B2545", borderColor: "var(--border)" }} data-testid="prelaunch-notice">
      <span className="flex items-center gap-1.5 font-semibold uppercase tracking-wider"><Rocket size={12} /> Pre-launch — not yet open to clients</span>
      <span className="opacity-80">Email is held for review · employer sign-in opens {formatEastern(info.go_live_at)}</span>
    </div>
  );
}

export function VersionStamp({ className = "" }) {
  const info = useSiteInfo();
  if (!info?.version) return null;
  return (
    <span className={`font-mono normal-case tracking-normal ${className}`} data-testid="version-stamp">
      v{info.version}{info.built_at ? ` · built ${new Date(info.built_at).toLocaleDateString("en-US", { dateStyle: "medium" })}` : ""}
    </span>
  );
}
